<div class="font-bold text-sm soft-overline mb-1">
  {{ '#WWS_WARENUEBERNAHME.KOPFDATEN.TITEL_KOPFDATEN' | translate }}
</div>

<div class="flex flex-col w-full border border-solid bg-surface rounded-md p-0">
  <div class="flex flex-row w-full justify-between border-b border-solid p-4">
    <span>{{ '#WWS_WARENUEBERNAHME.KOPFDATEN.LABEL_LIEFERANT' | translate }}</span>
    @if (!isBestellung) {
      <span>{{ warenuebernahme?.lieferant?.kurzbez }}</span>
    }
    @if (isBestellung) {
      <span>{{ bestellung?.lieferant?.kurzbez }}</span>
    }
  </div>
  @if (!isBestellung) {
    <div
      class="flex flex-row w-full justify-between border-b border-solid p-4"
      >
      <span>{{
        '#WWS_WARENUEBERNAHME.KOPFDATEN.LABEL_LIEFERSCHEIN_NUMMER' | translate
      }}</span>
      <span>{{ warenuebernahme?.belegnummer }}</span>
    </div>
  }
  @if (isBestellung) {
    <div class="flex flex-row w-full justify-between p-4">
      <span>{{ '#WWS_WARENUEBERNAHME.KOPFDATEN.LABEL_BESTELLNUMMER' | translate }}</span>
      @if (isBestellung) {
        <span>{{ bestellung?.bestellnummer }}</span>
      }
    </div>
  }
  @if (isBestellungUebernahme) {
    <div
      class="flex flex-col w-full p-4 border-t border-solid"
      >
      <span>{{
        '#WWS_WARENUEBERNAHME.KOPFDATEN.LABEL_LIEFERSCHEIN_NUMMER' | translate
      }}</span>
      <soft-input
        #lieferscheinnummerInput
        [type]="'text'"
        [placeholder]="'#WWS_WARENUEBERNAHME.KOPFDATEN.LABEL_LIEFERSCHEIN_NUMMER'"
        [class]="'w-full mt-4'"
        (valueChange)="lieferscheinnummerChange.emit(lieferscheinnummerInput.value() ?? '')"
        >
      </soft-input>
    </div>
  }
</div>
